import React from "react";

export default function Loading() {
  return (
    <div>
      <h1>Loading</h1>
    </div>
  );
}
